module.exports = __webpack_public_path__ + "img/myposition_cm_프랭키 더 용.c6a10b11.png";